import React, { useState } from "react";
import { Form, Modal, notification, Select, Tabs } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { ApolloError } from "apollo-boost";
import { teacherGql } from "../../../graphql/teacher";
import { UserListPanel } from "./UserListPanel";
import { SearchUserPanel } from "./SearchUserPanel";
import { AddTeacherPanel } from "./AddTeacherPanel";
import { observer } from "mobx-react";
import { Store } from "../../../store/Store";
import { Titles } from "../../../common/Fr";

const { TabPane } = Tabs;

export const AddTeacherDlg = observer(({ orgId, onClose }) => {
  const store = Store.orgsStore.orgView;

  const [setTeacher] = useMutation(teacherGql.setTeacher);
  const [curTeacher, setCurTeacher] = useState({ id: "", title: "" });
  const [showTitleDlg, setShowTitleDlg] = useState(false);

  const [form] = Form.useForm();

  const onSetTeacher = (user) => {
    setCurTeacher(user);
    if (user.title) {
      onAddTeacher(user.id, user.title);
    } else {
      form.resetFields();
      setShowTitleDlg(true);
    }
  };

  const onAddTeacher = (teacherId, title) => {
    setTeacher({ variables: { input: { orgId, teacherId, title, type: "Add" } } })
      .then(() => {
        notification.success({ message: `Add teacher successed!` });
        store.loadTeachers();
      })
      .catch((err: ApolloError) => {});
  };

  const onAdded = (ok) => {
    onClose();
  };

  const onTitleOk = () => {
    form.validateFields().then((values) => {
      setShowTitleDlg(false);
      onAddTeacher(curTeacher.id, values.title);
    });
  };

  return (
    <Modal title="Add Teacher" width={600} visible={true} maskClosable={false} onCancel={() => onClose()} footer={null}>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Select from Community Members" key="1">
          <UserListPanel selectText="Set as Teacher" members={store.notTeacherMembers} onSelect={onSetTeacher} />
        </TabPane>
        <TabPane tab="Find by Email" key="2">
          <SearchUserPanel selectText="Set as Teacher" onSelect={onSetTeacher} />
        </TabPane>
        <TabPane tab="Create New" key="3">
          <AddTeacherPanel orgId={orgId} onClose={onAdded} />
        </TabPane>
      </Tabs>
      <Modal
        visible={showTitleDlg}
        title="Select Salutation"
        centered
        onOk={onTitleOk}
        onCancel={() => setShowTitleDlg(false)}
      >
        <Form form={form}>
          <p>Please select title fro teacher</p>
          <Form.Item name="title" rules={[{ required: true, message: "Please select salutation" }]}>
            <Select placeholder="Select salutation" allowClear>
              {Titles.map((x) => (
                <Select.Option value={x} key={x}>
                  {x}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </Modal>
  );
});
